import(/* webpackMode: "eager" */ "/home/oreetiene/public_html/app/(otherPages)/politica-cookies/page.jsx");
